import VueRouter from 'vue-router';
import Section from './components/section-component.vue'
import Page from './components/page-component.vue'

const _routes = [
    {
        path: '/',
        redirect: '/fr/accueil'
    },
    {
        path: '/:locale/:sectionSlug',
        component: Section,
        name: 'section'
    },
    {
        path: '/:locale/:sectionSlug/:pageSlug',
        component: Page,
        name: 'page'
    }
]

var router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: _routes,
    linkActiveClass: 'active'
})

export default router
